import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseChargesAdjustmentTemplates = [
  {
    id: '-104001',
    language: Language.EN,
    subject: 'Charge provision adjustment',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CHARGES_ADJUSTMENT,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{listAllTenants lease}},</p>
        <p></p>
        <p>In accordance with the lease located at <strong>{{getLeaseMainAddress lease}}</strong>, having taken effect on <strong>{{formatDate lease.startDate}}</strong> your provisioned charges will be adjusted.</p>
        <p>In view of the growing difference between the provisions and the effective charges, and in order to avoid an excessive difference at the time of the next charge statement, we are adjusting your {{getLeasePaymentFrequency lease}} provisions from {{getLphPreviousMonthlyCharges leasePriceHistory}} € to <strong>{{adjustmentAmount}}</strong> €.</p>
        <p></p>
        {{#if (hasComment leasePriceHistory)}}
        <p>Comment:</p>
        <i>{{leasePriceHistory.comment}}</i>
        <p></p>
        {{/if}}
        <p>Thank you for taking this into account and to adjust the periodical amount of your direct debit.</p>
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-104002',
    language: Language.FR,
    subject: 'Ajustement des provisions de charges',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CHARGES_ADJUSTMENT,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère {{listAllTenants lease}},</p>
        <p></p>
        <p>Conformément au bail sis <strong>{{getLeaseMainAddress lease}}</strong> et ayant pris effet le <strong>{{formatDate lease.startDate}}</strong>, vos provisions de charges seront adaptées.</p>
        <p>Compte tenu de l'écart qui se creuse entre vos provisions et les charges réelles et dans un objectif d'éviter une différence trop importante lors du prochain décompte de charge, nous faisons passer vos provisions {{getLeasePaymentFrequency lease}} de {{getLphPreviousMonthlyCharges leasePriceHistory}} € à <strong>{{adjustmentAmount}}</strong> €.</p>
        <p></p>
        {{#if (hasComment leasePriceHistory)}}
        <p>Commentaire:</p>
        <i>{{leasePriceHistory.comment}}</i>
        <p></p>
        {{/if}}
        <p>Merci de bien vouloir prendre ces détails en considération et d'ajuster votre domiciliation périodique.</p>
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-104003',
    language: Language.NL,
    subject: 'Aanpassing van de provisies voor lasten',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CHARGES_ADJUSTMENT,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{listAllTenants lease}},</p>
        <p></p>
        <p>In overeenstemming met het huurcontract gelegen op <strong>{{getLeaseMainAddress lease}}</strong> ingegaan op <strong>{{formatDate lease.startDate}}</strong> wordt uw huur geïndexeerd.</p>
        <p>Gezien het toenemende verschil tussen de provisies en de effectieve lasten, en om een te groot verschil bij de volgende lastenafrekening te vermijden, passen wij uw {{getLeasePaymentFrequency lease}} provisies aan van {{getLphPreviousMonthlyCharges leasePriceHistory}} € naar <strong>{{adjustmentAmount}}</strong> €.</p>
        <p></p>
        {{#if (hasComment leasePriceHistory)}}
        <p>Opmerking:</p>
        <i>{{leasePriceHistory.comment}}</i>
        <p></p>
        {{/if}}
        <p>Dank u om hiermee rekening te houden en het periodieke bedrag van uw domiciliëring aan te passen.</p>
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-104004',
    language: Language.DE,
    subject: 'Anpassung der Nebenkostenvorauszahlungen',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CHARGES_ADJUSTMENT,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r {{listAllTenants lease}},</p>
        <p></p>
        <p>In Übereinstimmung mit dem Mietvertrag in <strong>{{getLeaseMainAddress lease}}</strong>, der am <strong>{{formatDate lease.startDate}}</strong> in Kraft getreten ist, werden Ihre Nebenkostenvorauszahlungen angepasst.</p>
        <p>Angesichts der wachsenden Differenz zwischen den Vorauszahlungen und den tatsächlichen Kosten und um eine übermäßige Differenz bei der nächsten Nebenkostenabrechnung zu vermeiden, passen wir Ihre {{getLeasePaymentFrequency lease}} Vorauszahlungen von {{getLphPreviousMonthlyCharges leasePriceHistory}} € auf <strong>{{adjustmentAmount}}</strong> € an.</p>
        <p></p>
        {{#if (hasComment leasePriceHistory)}}
        <p>Kommentar:</p>
        <i>{{leasePriceHistory.comment}}</i>
        <p></p>
        {{/if}}
        <p>Vielen Dank, dass Sie dies berücksichtigen und den periodischen Betrag Ihrer Lastschrift anpassen.</p>
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
